import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';

export default function DclEstablishmentRegReport() {
    let location = useLocation()
    let org_id = location?.state?.org_id
    let navigate = useNavigate()

    const [showList, setList] = useState([])

    function GetChequeInReport() {
        let url = config.url.BOC_URL + 'establishment/dclWise?zcl_org=' + org_id;
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.details);
            }
            else {
                setList([])
            }
        })
    }

    useEffect(() => { GetChequeInReport() }, [])
    const columns = [
        {
            Header: 'S.NO',
            accessor: (row, index) => index + 1,
            Footer: 'Total',

        },
        {
            Header: 'Org Name',
            accessor: 'org_name',
            Cell: ({ row }) =>
            (<span style={{ color: 'Highlight', textDecoration: 'underline' }}
                onClick={() => {
                    navigate('/AclEstablishmentReport', { state: { status: "own_approved", org_id: row?.original?.dcl_org } })
                }}>{row?.original?.org_name}</span>),
            Footer: '',
        },

        {
            Header: 'Through Individuals',
            accessor: 'Through Individuals',
            columns: [
                {
                    Header: 'Establishments',
                    columns: [
                        {
                            Header: 'Total',
                            accessor: "own_total",
                            Footer: 'own_total',
                        },
                        {
                            Header: 'Cess Amount',
                            accessor: "own_total_cess",
                            Footer: 'own_total_cess',
                        },

                    ],
                },
                {
                    Header: 'Fully Paid',
                    columns: [
                        {
                            Header: ' Total',
                            accessor: "own_full",
                            Footer: 'own_full',
                        },
                        {
                            Header: ' Cess Amount',
                            accessor: "own_full_paid_cess",
                            Footer: 'own_full_paid_cess',
                        },

                    ],
                },
                {
                    Header: 'Partial / Not Paid',
                    columns: [
                        {
                            Header: 'Total ',
                            accessor: "own_partilal",
                            Footer: 'own_partilal',
                        },
                        {
                            Header: 'Amount Received',
                            accessor: "own_partial_paid_cess",
                            Footer: 'own_partial_paid_cess',
                        },
                        {
                            Header: 'Balance',
                            accessor: "own_partial_balance",
                            Footer: 'own_partial_balance',
                        },

                    ],
                },
            ],
            Footer: '',
        },
    ]
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="DCL Wise Establishment Report" />
            <jnb.Container className="outer-page-content-container">
                <div className="table-responsive">
                    <CommonReactTable columns={columns} data={showList} showFooter="true" filename="DepartmentReport" />
                </div>
            </jnb.Container>
        </React.Fragment>
    )
}
